module.exports = __webpack_public_path__ + "4df89d69dc3cd5cca482716dce6b878f.pdf";